export enum UserTableColumns {
  name = "name",
  email = "email",
  createdAt = "createdAt",
}

export const USER_TABLE_COLUMN_LABELS: Record<UserTableColumns, string> = {
  [UserTableColumns.name]: "Name",
  [UserTableColumns.email]: "Email",
  [UserTableColumns.createdAt]: "Created",
};

export const DEFAULT_USER_TABLE_COLUMN_SETTINGS: Record<UserTableColumns, boolean> = {
  [UserTableColumns.name]: true,
  [UserTableColumns.email]: true,
  [UserTableColumns.createdAt]: true,
};

export const DEFAULT_USER_TABLE_COLUMN_ORDER: UserTableColumns[] = [
  UserTableColumns.name,
  UserTableColumns.email,
  UserTableColumns.createdAt,
];

// Helper functions to generate derived data
export const getColumnLabels = (): Record<string, string> => USER_TABLE_COLUMN_LABELS;
export const getDefaultColumnSettings = (): Record<string, boolean> => DEFAULT_USER_TABLE_COLUMN_SETTINGS;
export const getDefaultColumnOrder = (): string[] => DEFAULT_USER_TABLE_COLUMN_ORDER;